function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6237 3.49999V10.2083C9.6237 11.4975 8.57953 12.5417 7.29036 12.5417C6.0012 12.5417 4.95703 11.4975 4.95703 10.2083V2.91666C4.95703 2.11166 5.61036 1.45833 6.41536 1.45833C7.22036 1.45833 7.8737 2.11166 7.8737 2.91666V9.04166C7.8737 9.36249 7.6112 9.62499 7.29036 9.62499C6.96953 9.62499 6.70703 9.36249 6.70703 9.04166V3.49999H5.83203V9.04166C5.83203 9.84666 6.48536 10.5 7.29036 10.5C8.09536 10.5 8.7487 9.84666 8.7487 9.04166V2.91666C8.7487 1.62749 7.70453 0.583328 6.41536 0.583328C5.1262 0.583328 4.08203 1.62749 4.08203 2.91666V10.2083C4.08203 11.9817 5.51703 13.4167 7.29036 13.4167C9.0637 13.4167 10.4987 11.9817 10.4987 10.2083V3.49999H9.6237Z",
  fill: "currentColor"
});

function SvgAttachicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachicon);
export default __webpack_public_path__ + "static/media/attach.icon.0c665bbb.svg";
export { ForwardRef as ReactComponent };